const HIDECOOKIE_SEARCH_PARAM = 'hidecookie';

export function isHideCookieActive(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    const url = new URL(window.location.href);
    return url.searchParams.get(HIDECOOKIE_SEARCH_PARAM) === 'true';
}
